import React, { useEffect } from "react";
import TutorReviewMode from "../pages/review/TutorReviewMode";
import { TutorProvider } from "../context/AiTutorContext";
import { LearnProvider } from "../context/LearnContext";
import { PracticeProvider } from "../context/PracticeContext";
import { useLocation } from "@remix-run/react";
import useStateRef from "react-usestateref";
import { removeCookie } from "../utils/TutorConstants";
import { StorageService } from "../utils/StorageUtils";
import { useCustomNavigation } from "../hooks/useCustomNavigation";
import { ROUTES } from "../utils/navigationUtils";
import { useRoot } from "../context/RootContext";
export let loader = async () => {
  return { type: "review" };
};
const Review = () => {
  useCustomNavigation(ROUTES?.REVIEW);
  const location = useLocation();
  // console.log("state", location.state);
  const { journeyId, subjectMasterUuid, topicMasterUuid } =
    location.state || {};
  const { setIsDiscussFlow } = useRoot();
  useEffect(() => {
    removeCookie("taskProgressId");
    StorageService.removeItem("assesmentInfo");
    StorageService.removeItem("backUpObject");
    setIsDiscussFlow(false);
  }, []);

  return (
    <TutorProvider>
      <PracticeProvider>
        <LearnProvider>
          <TutorReviewMode
            journeyId={journeyId}
            subjectMasterUuid={subjectMasterUuid}
            topicMasterUuid={topicMasterUuid}
          />
        </LearnProvider>
      </PracticeProvider>
    </TutorProvider>
  );
};

export default React.memo(Review);
